// RankingAlert funnel destination URLs — configurable via env so they
// can be swapped for real Calendly / signup links without editing
// component code. Fallback to internal placeholder routes.
const withCid = (base, cid) => {
  if (!base) return "";
  const sep = base.includes("?") ? "&" : "?";
  return cid ? `${base}${sep}cid=${encodeURIComponent(cid)}` : base;
};

export const GET_STARTED_URL_BASE =
  process.env.REACT_APP_GET_STARTED_URL || "/get-started?ref=rankingalert";
export const BOOK_STRATEGY_URL_BASE =
  process.env.REACT_APP_BOOK_STRATEGY_URL || "/book-strategy?ref=rankingalert";

export const getStartedUrl = (cid) => withCid(GET_STARTED_URL_BASE, cid);
export const bookStrategyUrl = (cid) => withCid(BOOK_STRATEGY_URL_BASE, cid);
